
import mixpanel from 'mixpanel-browser';
import React from 'react';
import { Provider } from '../context/mixPanelContext';

const dataset = document.documentElement.dataset
const domain = document.location.href
const device = dataset.device
const browser_uid = dataset.browserUid
const mixpanelToken = dataset.mixpanelToken
const session_id = dataset.sessionId
const platform = 'web'
const product_type = 'consumer'
const partner = 'nest_maintenance'
const event_context = 'maintenance_funnel'

const defaults = {
  domain,
  platform,
  device,
  browser_uid,
  session_id,
  product_type,
  event_context,
  partner
};

const tracker = function(event = '', configs = {}) {
  this.track(event, {...defaults, ...configs})
}

const MixpanelProvider = ({ children }) => {
  mixpanel.init(mixpanelToken);
  mixpanel.tracker = tracker;
  return (
    <Provider value={mixpanel}>
      {children}
    </Provider>
  );
};

export default MixpanelProvider;